<div id="{{ createAttributeIdForConfigurator(attribute) }}" class="d-flex">
  <ng-container *ngIf="attribute.values != undefined && attribute.values.length > 0; else noStaticDomain">
    <ng-container *ngFor="let value of attribute.values">
      <div
        id="{{ createValueUiKey('label', attribute.name, value.valueCode) }}"
        class="d-flex align-items-start body--s text-grey"
        [class.ps-1]="isDate(value)"
        *ngIf="value.selected"
        tabindex="0">
        <span *ngIf="isDate(value); else displayDurationHtml">
          {{ value.valueDisplay | date: 'dd MMM yyyy' }}
        </span>
        <ng-template #displayDurationHtml> <span [innerHtml]="value.valueDisplay"></span></ng-template>
        <dcp-icon-button-tooltip
          *ngIf="value.description"
          [placement]="'Right'"
          [openOnClick]="true"
          accessibleName="attributeValueTooltip">
          <span class="text-grey body--s">{{ value.description }}</span>
        </dcp-icon-button-tooltip>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #noStaticDomain>
    <ng-container *ngIf="attribute.selectedSingleValue">
      <div
        id="{{ createValueUiKey('label', attribute.name, attribute.selectedSingleValue) }}"
        class="body--s text-grey"
        tabindex="0">
        <span>{{ attribute.selectedSingleValue }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="attribute.userInput">
      <div
        id="{{ createValueUiKey('label', attribute.name, attribute.userInput) }}"
        class="body--s text-grey"
        tabindex="0">
        <span>{{ attribute.userInput }}</span>
      </div>
    </ng-container>
  </ng-template>
</div>
